import { motion, useScroll, useTransform } from "framer-motion";

const LETTERS = [
  { c: "ق", t: "14%", l: "3%", s: 55, r: -4, d: 1.1 },
  { c: "م", t: "13%", l: "86%", s: 72, r: -24, d: 3.0 },
  { c: "ب", t: "3%", l: "11%", s: 51, r: -6, d: 2.5 },
  { c: "ا", t: "71%", l: "25%", s: 72, r: 18, d: 1.1 },
  { c: "غ", t: "35%", l: "0%", s: 48, r: 19, d: 1.7 },
  { c: "ج", t: "27%", l: "43%", s: 44, r: -24, d: 1.9 },
  { c: "س", t: "44%", l: "77%", s: 54, r: -30, d: 3.6 },
  { c: "ع", t: "15%", l: "48%", s: 43, r: 35, d: 1.5 },
  { c: "ق", t: "79%", l: "46%", s: 74, r: -11, d: 3.5 },
  { c: "ب", t: "84%", l: "29%", s: 56, r: -25, d: 4.3 },
  { c: "ل", t: "87%", l: "82%", s: 42, r: -14, d: 2.7 },
  { c: "د", t: "20%", l: "59%", s: 62, r: -1, d: 4.9 },
  { c: "ن", t: "7%", l: "29%", s: 40, r: 5, d: 2.0 },
  { c: "ت", t: "27%", l: "72%", s: 58, r: -8, d: 3.3 },
  { c: "ش", t: "82%", l: "58%", s: 47, r: -2, d: 0.7 },
  { c: "م", t: "71%", l: "68%", s: 54, r: 19, d: 4.5 },
  { c: "ش", t: "46%", l: "28%", s: 46, r: 30, d: 2.5 },
  { c: "ص", t: "76%", l: "8%", s: 62, r: 13, d: 3.0 },
  { c: "ض", t: "67%", l: "32%", s: 73, r: -34, d: 3.4 },
  { c: "ث", t: "87%", l: "68%", s: 55, r: 8, d: 0.6 },
  { c: "ص", t: "20%", l: "58%", s: 38, r: -2, d: 4.9 },
  { c: "ن", t: "22%", l: "64%", s: 44, r: 3, d: 4.2 },
  { c: "ظ", t: "77%", l: "25%", s: 47, r: 12, d: 3.8 },
  { c: "ع", t: "67%", l: "0%", s: 76, r: 6, d: 2.4 },
  { c: "ث", t: "46%", l: "39%", s: 53, r: -28, d: 1.2 },
  { c: "غ", t: "10%", l: "10%", s: 69, r: -27, d: 4.9 },
  { c: "ح", t: "55%", l: "90%", s: 60, r: 14, d: 2.2 },
  { c: "ر", t: "90%", l: "12%", s: 50, r: -18, d: 3.8 },
];

export default function ArabicScatter() {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1400], [0, -160]);

  return (
    <motion.div className="arabic-scatter" style={{ y }} aria-hidden="true">
      {LETTERS.map((L, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.42 }}
          transition={{ duration: 2.2, delay: 0.3 + i * 0.05 }}
          style={{
            top: L.t,
            left: L.l,
            fontSize: L.s,
            transform: `rotate(${L.r}deg)`,
            animationDelay: `${L.d}s`,
          }}
        >
          {L.c}
        </motion.span>
      ))}
    </motion.div>
  );
}
